<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<ng-container *ngIf="!loading">
  <div class="context">
    <div class="ctx-left">
      <div class="ctx-logo">
        <app-image
          *ngIf="platformInfo.product_icon"
          [fileid]="platformInfo.product_icon"
          [radius]="8"
        ></app-image>
        <!-- 演示数据没有真实产品图时，用首字母图标兜底 -->
        <span class="demo-logo" *ngIf="!platformInfo.product_icon">{{
          (platformInfo.order?.platform_name || "?").charAt(0)
        }}</span>
      </div>
      <div class="ctx-copy">
        <strong>{{ platformInfo.order.platform_name }}</strong>
        <span>{{ platformInfo.account }}</span>
        <div class="path"><i class="chip">当前账号</i></div>
      </div>
    </div>
  </div>
  <h2 class="title">遇到了什么问题？</h2>
  <!-- <div class="template"><i></i><span>影音会员常见问题模板</span></div> -->
  <div class="tabs">
    <button
      *ngFor="let item of data; let i = index"
      class="tab"
      [ngClass]="{ active: index === i }"
      (click)="selectTab(i)"
    >
      {{ item.name }}
    </button>
  </div>
  <div class="issues">
    <button
      type="button"
      class="issue"
      *ngFor="let item of data[index].items"
      (click)="chooseIssue(item)"
    >
      <span class="issue-copy">
        <strong>{{ item.name }}</strong>
      </span>
      <span class="issue-right">
        <i class="tag">{{ item.short_desc }}</i>
        <ng-container *ngIf="tag(item.tag)">
          <i class="tag" [ngClass]="item.tag">
            {{ tag(item.tag) }}
          </i>
        </ng-container>
        <b class="chev">›</b>
      </span>
    </button>
  </div>
  <!-- <div class="back">
    <button class="link" (click)="backStep()">‹ 返回选择账号</button>
  </div> -->
</ng-container>
